import script from "./BoxGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxGeneral.vue?vue&type=script&setup=true&lang=js"

import "./BoxGeneral.vue?vue&type=style&index=0&id=3eb0039e&lang=scss&scoped=true"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AccessIntegrationSite\\access-integration\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb0039e"]])

export default __exports__